import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { POSITION_BG, MATURITY_BG } from "@/lib/constants";
import { Users, ChevronDown, ChevronUp } from "lucide-react";

export const CollectiveVoice = () => {
  const [perspectives, setPerspectives] = useState([]);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    api.get("/perspectives").then((r) => setPerspectives(r.data.perspectives));
  }, []);

  if (!perspectives.length) return null;

  return (
    <div className="bg-slate-900 rounded-xl border border-slate-800 overflow-hidden" data-testid="collective-voice-panel">
      <button
        data-testid="collective-voice-toggle"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-slate-800/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-teal-500/20 border border-teal-500/40 flex items-center justify-center">
            <Users className="w-4 h-4 text-teal-400" />
          </div>
          <div>
            <p className="font-heading font-bold text-white text-sm">Collective HCP Voice — Principal Insights</p>
            <p className="text-[11px] text-slate-400">Aggregated, synthesised perspectives · the primary intelligence layer; individual statements below are supporting evidence</p>
          </div>
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
          {perspectives.map((p) => (
            <div key={p.id} data-testid={`perspective-card-${p.id}`} className="bg-slate-800/60 border border-slate-700/70 rounded-lg p-4">
              <div className="flex items-start justify-between gap-2">
                <p className="font-heading font-bold text-white text-sm leading-snug">{p.name}</p>
                <span className="font-mono text-[10px] text-slate-500 shrink-0">{p.hcp_basis.toLocaleString()} {p.hcp_basis_derived ? "verified statements" : "HCPs"}</span>
              </div>
              <p className="text-[10px] font-mono uppercase tracking-widest text-teal-400 mt-0.5">{p.scope}</p>
              <p className="text-xs text-slate-300 leading-relaxed mt-2">{p.synthesis}</p>
              <div className="flex flex-wrap gap-1.5 mt-3">
                <Badge variant="outline" className={`text-[10px] ${POSITION_BG[p.dominant_position]}`}>{p.dominant_position}</Badge>
                <Badge variant="outline" className={`text-[10px] ${MATURITY_BG[p.maturity]}`}>{p.maturity}</Badge>
              </div>
              <p className="text-[10px] text-slate-500 mt-2">Key tension: <span className="text-slate-400">{p.key_tension}</span> · {p.insight_ids.length} supporting statements</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
